import React from "react"; 
import { Link } from "react-router-dom";    
import EditCategoryForm from "../../../components/Dashboard/Categories/Edit";

const EditCategory = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">
        <h5>Edit Category</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>
          <Link to="/categories">
              Categories
            </Link>
          </li>
          <li>Edit Category</li>
        </ul>
      </div> */}

      <EditCategoryForm />
    </>
  );
};

export default EditCategory;
